"use client";

import { type FC, useEffect, useState } from "react";
import { motion } from "motion/react";
import { Flex, type Timeout, Placeholder, Stack, Reveal } from "@huub-web/ui";
import { addParamsToURL, rem } from "@huub-web/utils";

import { Calendly, type CalendlyProps } from "../Calendly";
import { loadingContainerStyle } from "./AppointmentController.css";

export type AppointmentControllerProps = {
  prefill: CalendlyProps["prefill"];
  onLoadingChange?: (isLoading: boolean) => void;
  url: string;
};

export const AppointmentController: FC<AppointmentControllerProps> = ({
  prefill,
  url,
  onLoadingChange,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    onLoadingChange?.(isLoading);

    if (!isLoading) {
      return;
    }

    const timeout: Timeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isLoading]);

  const calendlyURL = addParamsToURL(url, {
    hide_event_type_details: "1",
  });

  return (
    <Stack>
      <motion.div animate={{ opacity: isLoading ? 0 : 1 }}>
        <Calendly url={calendlyURL} height={630} prefill={prefill} />
      </motion.div>

      <Reveal>
        {isLoading && (
          <Flex
            direction="column"
            gap="s"
            align="center"
            justify="center"
            className={loadingContainerStyle}
          >
            <Placeholder variant="loading" width={rem(180)} height={rem(30)} />
            <div />
            <Placeholder variant="loading" width={rem(220)} height={rem(40)} />
            <Placeholder variant="loading" width={rem(300)} height={rem(320)} />
          </Flex>
        )}
      </Reveal>
    </Stack>
  );
};
